module.exports = __webpack_public_path__ + "static/media/mana.820a9bed.svg";